export const generateContent = ({
  text,
  length,
  expanded,
  component
}) => {
  const textPreview = length < text.length ? `${text.slice(0, length)} ...` : text
  const content = expanded ? text : textPreview

  return length < text.length ? content + component : content
}
